module.exports = __webpack_public_path__ + "static/img/sourceBanner.0ad6786.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/source/sourceBanner.png
// module id = ZvYB
// module chunks = 0